import {Component, OnChanges, OnInit} from '@angular/core';
import {TableService} from '../../services/table.service';
import {BinKeysService} from '../../services/bin-keys.service';
import * as _ from 'lodash';
import {saveAs} from 'file-saver';
import {DatePipe} from '@angular/common';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {SymbolsService} from '../../services/symbols.service';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {BaseClientComponent} from '../base-client.component';

@Component({
  selector: 'app-encryption-keys',
  templateUrl: './encryption-keys.component.html',
  styleUrls: ['./encryption-keys.component.scss']
})
export class EncryptionKeysComponent extends BaseClientComponent implements OnInit, OnChanges {
  encryptionKeysInfo: any;
  columns: any;
  week1: Date;
  week2: Date;
  week3: Date;
  noKeys = false;
  notFoundKeys = false;

  constructor(public tableService: TableService,
              private binKeyService: BinKeysService,
              protected utilsService: UtilsService,
              public authenticationService: AuthenticationService,
              private symbolsService: SymbolsService,
              public datePipe: DatePipe) {
    super();
    this.getWeek1And2And3();
  }

  private getWeek1And2And3() {
    const nowDate = new Date();
    const day = nowDate.getDay();
    if (day === 0) {
      this.week1 = new Date(nowDate.setDate(nowDate.getDate() - 7));
      this.week2 = new Date(nowDate.setDate(nowDate.getDate() + 7));
      this.week3 = new Date(nowDate.setDate(nowDate.getDate() + 7));
    } else {
      this.week1 = new Date(nowDate.setDate(nowDate.getDate() - day));
      this.week2 = new Date(nowDate.setDate(nowDate.getDate() + 7));
      this.week3 = new Date(nowDate.setDate(nowDate.getDate() + 7));
    }
  }

  ngOnInit() {
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.ngOnChanges();
    });
    this.subscriptions.push(response$);
  }

  ngOnChanges() {
    this.getClientEncryptionKeys();
    this.initializeColumnsForCommercialPopList();
  }

  private initializeColumnsForCommercialPopList() {
    this.columns = [
      {field: 'pop', header: 'Pops', sortDisabled: false},
      {field: 'channel', header: 'Channel', sortDisabled: true},
      {field: 'products', header: 'Md Product', sortDisabled: true},
      {field: 'protected', header: 'Protected'},
      {field: 'date1', header: 'Week 1', sortDisabled: true},
      {field: 'date2', header: 'Week 2', sortDisabled: true},
      {field: 'date3', header: 'Week 3', sortDisabled: true}
    ];
  }

  getClientEncryptionKeys() {
    this.binKeyService.getEncryptionKeysInfo().subscribe({
        next: encryptionKeysInfo => {
          if (encryptionKeysInfo.length > 0) {
            this.encryptionKeysInfo = this.groupKeysAccordingToPopsAndChannels(encryptionKeysInfo);
          } else {
            this.noKeys = true;
          }
        }, error: () => {
          this.noKeys = true;
        }
      }
    );
  }

  groupKeysAccordingToPopsAndChannels(encryptionKeysInfo) {
    const groupKeys = [];
    const listPop = encryptionKeysInfo
      .map(binKey => binKey.pop)
      .sort();
    const allPops = _.uniq(listPop);
    const listChannels = encryptionKeysInfo
      .map(binKey => binKey.channel)
      .sort();
    const allChannels = _.uniq(listChannels);
    let availableBinKeys = [];
    let weeks = [];
    for (const pop of allPops) {
      for (const channel of allChannels) {
        availableBinKeys = encryptionKeysInfo.filter(binKey => binKey.pop === pop && binKey.channel === channel);
        if (availableBinKeys.length > 0) {
          const protectedValues = _.uniq(availableBinKeys.map(binKey => binKey.protected));
          for (const protectedValue of protectedValues) {
            const filteredKeys = availableBinKeys.filter(binKey => binKey.protected === protectedValue);
            weeks = filteredKeys.map(binKey => binKey.date);
            groupKeys.push({
              'pop': pop,
              'channel': channel,
              'products': filteredKeys[0].products,
              'protected': protectedValue,
              'weeks': _.uniq(weeks).sort()
            });
          }
          weeks = [];
        }
      }
    }
    return groupKeys;
  }

  downloadAvailableEncryptionKeys() {
    this.binKeyService.downloadAvailableEncryptionKeys()
      .subscribe({
        next: (response) => {
          const blob = this.symbolsService.b64toBlob(response['file_content'], response['mime_type'], null);
          saveAs(blob, response['file_name']);
        }, error: () => {
          this.notFoundKeys = true;
        }
      });
  }

  getWeek1(key) {
    if (key.weeks.length >= 1) {
      return key.weeks.sort()[0];
    }
    return '';
  }

  getWeek2(key) {
    if (key.weeks.length >= 2) {
      return key.weeks.sort()[1];
    }
    return '';
  }

  getWeek3(key) {
    if (key.weeks.length >= 3) {
      return key.weeks.sort()[2];
    }
    return '';
  }
}
